import { render, staticRenderFns } from "./BrokerFirmContactAddEditDialog.vue?vue&type=template&id=5a61021e&scoped=true"
import script from "./BrokerFirmContactAddEditDialog.vue?vue&type=script&lang=js"
export * from "./BrokerFirmContactAddEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61021e",
  null
  
)

export default component.exports